import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import EchartComparison from '../dashboard/idealscomparison';
import * as axiosInstance from '../utils/axiosinstace';
import moment from "moment";import { useTranslation } from 'react-i18next';


const GrowthCurveComponentNew = (props) => {
  const { t } = useTranslation(['common', 'analytics', 'device', 'farm', 'batch', 'user']);
    const hasInterpMale = props.data && props.data.some(row => row.isInterpolatedMale);
    const hasInterpFemale = props.data && props.data.some(row => row.isInterpolatedFemale);

    const columns_male = [
        {
            name: t('common:time.day'),
            selector: row => row.day,
            sortable: true,
        },
        {
            name: t('analytics:growth.actualWeightKgLower'),
            cell: row => {
                if (row.actualMale !== null) return (row.actualMale / 1000).toFixed(3);
                if (row.isInterpolatedMale && row.interpolatedMale !== null) {
                    return <span style={{ color: '#FF8C00' }}>({(row.interpolatedMale / 1000).toFixed(3)}) *</span>;
                }
                return '--';
            },
            sortable: true,
            sortFunction: (a, b) => (a.actualMale || 0) - (b.actualMale || 0)
        },
        {
            name: t('analytics:growth.idealWeightKgLower'),
            selector: row => row.idealMale !== null ? (row.idealMale / 1000).toFixed(3) : '--',
            sortable: true,
        }
    ];

    const columns_female = [
        {
            name: t('common:time.day'),
            selector: row => row.day,
            sortable: true,
        },
        {
            name: t('analytics:growth.actualWeightKgLower'),
            cell: row => {
                if (row.actualFemale !== null) return (row.actualFemale / 1000).toFixed(3);
                if (row.isInterpolatedFemale && row.interpolatedFemale !== null) {
                    return <span style={{ color: '#FF8C00' }}>({(row.interpolatedFemale / 1000).toFixed(3)}) *</span>;
                }
                return '--';
            },
            sortable: true,
            sortFunction: (a, b) => (a.actualFemale || 0) - (b.actualFemale || 0)
        },
        {
            name: t('analytics:growth.idealWeightKgLower'),
            selector: row => row.idealFemale !== null ? (row.idealFemale / 1000).toFixed(3) : '--',
            sortable: true,
        }
    ];

    const columns = [
        {
            name: t('common:time.day'),
            selector: row => row.day,
            sortable: true,
        },
        {
            name: t('analytics:growth.actualWeightKgLower'),
            cell: row => {
                const maleWeight = row.actualMale;
                const femaleWeight = row.actualFemale;
                if (maleWeight !== null && femaleWeight !== null) {
                    return (((maleWeight + femaleWeight) / 2) / 1000).toFixed(3);
                }
                if (maleWeight !== null) return (maleWeight / 1000).toFixed(3);
                if (femaleWeight !== null) return (femaleWeight / 1000).toFixed(3);
                if (row.isInterpolatedMale && row.interpolatedMale !== null) {
                    return <span style={{ color: '#FF8C00' }}>({(row.interpolatedMale / 1000).toFixed(3)}) *</span>;
                }
                return '--';
            },
            sortable: true,
            sortFunction: (a, b) => (a.actualMale || 0) - (b.actualMale || 0)
        },
        {
            name: t('analytics:growth.idealWeightKgLower'),
            selector: row => {
                const maleIdeal = row.idealMale;
                const femaleIdeal = row.idealFemale;
                if (maleIdeal !== null && femaleIdeal !== null) {
                    return (((maleIdeal + femaleIdeal) / 2) / 1000).toFixed(3);
                }
                if (maleIdeal !== null) return (maleIdeal / 1000).toFixed(3);
                if (femaleIdeal !== null) return (femaleIdeal / 1000).toFixed(3);
                return '--';
            },
            sortable: true,
        }
    ];

    useEffect(() => {

     },[]);

    const footnote = <p style={{ color: '#FF8C00', fontSize: 12, marginTop: 5 }}>*: Estimated Weight</p>;

    return (
        <div className="growthCurve">
            {
                props.sexing === 'yes' ?
                <div>
                    <div className="row" style={{paddingTop: 20, paddingBottom: 20}}>
                        <div className="col-md-3">
                            <h3>{t('analytics:growth.birdGrowthMale')}</h3>
                        </div>
                        <div className="col-md-9">
                            <ul className="batchInfo">
                                <li><b>{t('analytics:growth.batchNameColon')} </b>{props.batchInfo.batchName}</li>
                                <li><b>{t('analytics:growth.batchStatusColon')} </b><span className="textHiglighter" style={{background: props.batchInfo.batchStatus === 'ACTIVE' ? '#218838' : '#444'}}>{props.batchInfo.batchStatus}</span></li>
                                <li><b>{t('analytics:growth.startDateColon')} </b>{props.batchInfo.startDate ? moment(props.batchInfo.startDate).format('DD-MMM-YYYY') : '--'}</li>
                                <li><b>{t('analytics:growth.endDateColon')} </b>{props.batchInfo.endDate ? moment(props.batchInfo.endDate).format('DD-MMM-YYYY') : '--'}</li>
                                <li><b>{t('analytics:growth.sexingColon')} </b>{props.batchInfo.sexing === 'yes' ? 'Yes' : 'No'}</li>
                            </ul>
                        </div>
                    </div>
                     <div className="row">
                        <div className="col-md-6">
                            <DataTable
                                columns={columns_male}
                                data={props.data}
                                defaultSortField="day"
                                pagination
                                dense
                                selectableRowsHighlight={true}
                                compact
                                highlightOnHover={true}
                            />
                            {hasInterpMale && footnote}
                        </div>
                        <div className="col-md-6">
                            <EchartComparison
                                key={Math.random()}
                                xaxis={props.xaxis}
                                legends={props.maleLegends}
                                series={props.maleseries}
                                max='4'
                            />
                        </div>
                    </div>
                    <div className="row" style={{paddingTop: 40}}>
                        <div className="col-md-12">
                            <h3>{t('analytics:growth.birdGrowthFemale')}</h3>
                        </div>
                        <div className="col-md-6">
                            <DataTable
                                columns={columns_female}
                                data={props.data}
                                defaultSortField="day"
                                pagination
                                dense
                                selectableRowsHighlight={true}
                                compact
                                highlightOnHover={true}
                            />
                            {hasInterpFemale && footnote}
                        </div>
                        <div className="col-md-6">
                            <EchartComparison
                                key={Math.random()}
                                xaxis={props.xaxis}
                                legends={props.femaleLegends}
                                series={props.femaleseries}
                                max='4'
                            />
                        </div>
                    </div>
                </div>
                :
                <div>
                     <div className="row" style={{paddingTop: 20, paddingBottom: 20}}>
                        <div className="col-md-3">
                            <h3>{t('analytics:growth.birdGrowth')}</h3>
                        </div>
                        <div className="col-md-9">
                            <ul className="batchInfo">
                                <li><b>{t('analytics:growth.batchNameColon')} </b>{props.batchInfo.batchName}</li>
                                <li><b>{t('analytics:growth.batchStatusColon')} </b><span className="textHiglighter" style={{background: props.batchInfo.batchStatus === 'ACTIVE' ? '#218838' : '#444'}}>{props.batchInfo.batchStatus}</span></li>
                                <li><b>{t('analytics:growth.startDateColon')} </b>{props.batchInfo.startDate ? moment(props.batchInfo.startDate).format('DD-MMM-YYYY') : '--'}</li>
                                <li><b>{t('analytics:growth.endDateColon')} </b>{props.batchInfo.endDate ? moment(props.batchInfo.endDate).format('DD-MMM-YYYY') : '--'}</li>
                                <li><b>{t('analytics:growth.sexingColon')} </b>{props.batchInfo.sexing === 'yes' ? 'Yes' : 'No'}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <DataTable
                                columns={columns}
                                data={props.data}
                                defaultSortField="day"
                                pagination
                                dense
                                selectableRowsHighlight={true}
                                compact
                                highlightOnHover={true}
                            />
                            {hasInterpMale && footnote}
                        </div>
                        <div className="col-md-6">
                            <EchartComparison
                                key={Math.random()}
                                xaxis={props.xaxis}
                                legends={props.chickLegends}
                                series={props.asHatchedSeries}
                                max='5'
                            />
                        </div>
                    </div>
                </div>
            }

        </div>

    );
}

export default GrowthCurveComponentNew;
